<template>
  <!-- 搜索 -->
  <div class="header-bar">
    <div class="bar-lef">
      <div class="lef-one">
        <a-button class="btn-primary" @click="handleAdd">添加直连账号</a-button>
      </div>
    </div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-select
            v-model:value="searchForm.ota_id"
            placeholder="请选择渠道"
            @change="getOtaList"
        >
          <a-select-option :value="0">所有渠道</a-select-option>
          <a-select-option
              v-for="(item, index) in CompanyOta"
              :key="index"
              :value="item.id"
          >{{ item.name }}
          </a-select-option
          >
        </a-select>
      </div>
      <div class="rig-one">
        <a-input-search
            v-model:value="searchForm.name"
            :loading="searchLoading"
            allowClear
            placeholder="请输入账号名称"
            @search="getOtaList"
        >
        </a-input-search>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'ota_name'">
        <div class="ota-name">
          <div class="name-avatar">
            <a-avatar :size="34" :src="record.logo"></a-avatar>
          </div>
          <div class="name-name">{{ record.ota_name }}</div>
        </div>
      </template>
      <template v-if="column.key == 'ota_status'">
        <div v-if="record.ota_status == 1" class="f-c-green">在线</div>
        <div v-else-if="record.ota_status == 2" class="f-c-red">离线</div>
        <div v-else-if="record.ota_status == 3">密码错误</div>
      </template>
      <template v-if="column.key == 'status'">
        <div v-if="record.status == 1" class="f-c-green">正常</div>
        <div v-else class="f-c-red">停用</div>
      </template>
      <!-- <template v-if="column.key == 'ota_time'">
        <div class="ota-name">
          {{ diffTime(record.) }}
        </div>
      </template> -->
      <template v-if="column.key == 'operate'">
        <a-button
            v-for="im in record.sync"
            v-show="record.ota_status == 1"
            :key="im.type"
            :disabled="im.countdown > 0 || readLoading"
            type="link"
            @click="handleRead(im)"
        >{{
            im.countdown > 0 ? readOrderTime(im.countdown) : im.name
          }}
        </a-button
        >

        <a-button v-if="record.ota_id == 17" type="link" @click="handleByCallBackUrl(record)">
          推送地址
        </a-button>
        <a-button v-if="record.ota_id == 17" type="link" @click="handleCheckLine(record)">
          验证账号
        </a-button>

        <a-button
            v-show="record.ota_id == 19"
            type="link"
            @click="handleAddEdit(record)">
          修改标识
        </a-button>

        <a-button
            v-show="record.ota_status == 2 && record.ota_id != 19"
            class="f-c-red"
            type="link"
            @click="handleAddEdit(record)">
          重新登录
        </a-button>

        <!--        <a-button type="link" @click="handleStatus(record)">-->
        <!--          <span v-if="record.status == 1" class="f-c-red">停用</span>-->
        <!--          <span v-else class="f-c-green">启用</span>-->
        <!--        </a-button>-->

        <a-button class="f-c-red" type="link" @click="handleDel(record)">
          删除账号
        </a-button>
      </template>
    </template>
  </a-table>

  <!-- 渠道列表弹窗 -->
  <a-modal v-model:visible="visibleOtaList" :footer="null" :title="modalTitle">
    <div class="ota-list">
      <template v-for="(item, index) in CompanyOta" :key="index">
        <div
            v-if="item.ota_id !== 0"
            class="ota-one"
            @click="handleAddEdit(item)"
        >
          <a-avatar :size="25" :src="item.logo" style="width: 25px"></a-avatar>
          <span class="t-h-1">{{ item.name }}</span>
        </div>
      </template>
    </div>
  </a-modal>
  <!-- 云掌柜引导 -->
  <a-modal v-model:visible="yzgGuideShow" :footer="null" title="云掌柜">
    <div class="yzgGuide" @click="handleYzgLogin">
      已有云掌柜账号，
      <span class="f-c-red f-18">去添加</span>
      <div class="f-c-999">登录云掌柜平台，进入【右上角设置→个性配置→公安登记】页面，开通功能即可</div>
    </div>
    <div class="yzgGuide" @click="handleReister">
      还没有云掌柜账号，
      <span class="f-c-red f-18">去注册</span>
      <div class="f-c-999">为房东提供快捷注册功能，如果已注册，也可以在【渠道直接->云掌柜账号】查看注册记录</div>
    </div>
  </a-modal>
  <!-- 云掌柜注册成功提示 -->
  <a-modal v-model:visible="yzgRegisterSuccessShow" :footer="null" title="云掌柜-注册成功">
    <div>
      <div style=";margin-left: 30px;">账号：{{ yzgRegisterForm.phone }}</div>
      <div style="margin-top: 10px;margin-left: 30px;">密码：{{ yzgPassword }}</div>
      <div class="f-c-red" style="margin-top: 20px;">密码为默认的初始化密码，为了确保你的账号安全，请及时修改密码！</div>
      <div class="f-c-red">也可在【渠道直接->云掌柜账号】查看注册记录</div>
    </div>
  </a-modal>

  <!-- 民宿 -->
  <a-modal v-model:visible="msShow" :title="showTitle" @ok="handleConfirm">
    <div v-if="msForm.ota_id === 19" class="ms">
      <a-form
          ref="msFormRef"
          :model="msForm"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            v-if="[19].includes(msForm.ota_id)"
            :rules="[{ required: true, message: '请输入标识码' }]"
            label="标识码"
            name="account"
        >
          <a-input v-model:value="msForm.account"/>
        </a-form-item>
        <div v-if="msForm.ota_id == 19">
          <div class="f-c-red">注意事项</div>
          <div>标识码：由云掌柜提供，在云掌柜开通功能时，产生标识码</div>
          <div>步骤一：先在云掌柜开通公安登记功能</div>
          <div>步骤二：复制标识码并确定</div>
          <div>步骤三：尝试读取房源、读取订单，如果出现无数据或不正确，请联系客服协助处理</div>
        </div>
      </a-form>
    </div>
    <div v-else class="ms">
      <a-form
          ref="msFormRef"
          :model="msForm"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            v-if="[6,17].includes(msForm.ota_id)"
            :label="msForm.ota_id == 17 ? 'appid' : '账号'"
            :rules="[{ required: true, message: '请输入账号' }]"
            name="account"
        >
          <a-input v-model:value="msForm.account"/>
        </a-form-item>

        <a-form-item
            v-if="[6,17].includes(msForm.ota_id)"
            :label="msForm.ota_id == 17 ? 'secret' : '密码'"
            :rules="[{ required: true, message: '请输入密码' }]"
            name="pwd"
        >
          <a-input-password v-model:value="msForm.pwd"/>
        </a-form-item>
        <div v-if="msForm.ota_id == 17">
          <div class="f-c-red">注意事项</div>
          <div>步骤一：先添加一个不正确的appid和secret，并且【确定】</div>
          <div>步骤二：在账号列表中，获取【推送地址】,提供此推送地址宝寓</div>
          <div>步骤三：联系宝寓客服，获取正确的appid和secret，然后【重新登录】</div>
          <div class="f-c-red">如果列表中不存在重新登录，点击【验证账号】，则出现【重新登录】</div>
        </div>
      </a-form>
    </div>
  </a-modal>
  <!-- 云掌柜注册 -->
  <a-modal v-model:visible="yzgRegisterShow" title="云掌柜账号注册" @ok="handleYzgRegister">
    <div class="ms">
      <a-form
          ref="registerFormRef"
          :label-col="{ style: { width: '80px' } }"
          :model="yzgRegisterForm"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            :rules="[{ required: true, message: '请输入姓名' }]"
            label="姓名"
            name="user_name"
        >
          <a-input v-model:value="yzgRegisterForm.user_name" placeholder="姓名"/>
        </a-form-item>
        <a-form-item
            :rules="[{ required: true, message: '请输入手机号' }]"
            label="手机号"
            name="phone"
        >
          <a-input v-model:value="yzgRegisterForm.phone" placeholder="手机号码"/>
        </a-form-item>
        <a-form-item :rules="[{ required: true, message: '请输入验证码' }]" label="验证码" name="code">
          <div class="code-container">
            <a-input
                v-model:value="yzgRegisterForm.code"
                :autocomplete="false"
                class="code-box"
                placeholder="验证码"
                size="large"
            ></a-input>
            <a-button
                :disabled="disabled"
                class="btn-info"
                size="large"
                style="color: #666666 !important; width: 110px"
                @click="handleGetCode"
            >{{ codeText }}{{ count ? count + "秒" : null }}
            </a-button>
          </div>

        </a-form-item>
        <a-form-item
            :rules="[{ required: true, message: '请输入门店名称' }]"
            label="门店名称"
            name="store_name"
        >
          <a-input v-model:value="yzgRegisterForm.store_name" placeholder="门店名称"/>
        </a-form-item>
        <a-form-item
            :rules="[{ required: true, message: '请选择地市' }]"
            label="所在地市"
            name="city_name"
        >
          <a-select
              v-model:value="yzgRegisterForm.city_id"
              :dropdownMatchSelectWidth="false"
              :filter-option="filterOption"
              allowClear="true"
              max-tag-count="responsive"
              placeholder="所在地市"
              show-search
              @change="handleChange"
          >
            <a-select-option
                v-for="item in city_list"
                :key="item.city_id"
                :value="item.city_id"
            >{{ item.city_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
  <!-- 宝寓回调地址 -->
  <a-modal v-model:visible="byCallBackUrlShow" title="推送地址" @ok="byCallBackUrlShow = false">
    <div style="text-align: center">
      <div class="f-c-green f-16">温馨提示</div>
      <div class="f-c-red">以下是提供给宝寓的订单推送的接口地址：</div>
      <span>{{ byCallBackUrl }}</span>
      <span class="f-c-red" style="margin-left: 30px;" @click="handleCopy(byCallBackUrl)">点击复制</span>
    </div>
  </a-modal>
  <!-- 宝寓账号验证-->
  <a-modal v-model:visible="byCheckAccountShow" title="验证账号" @ok="byCheckAccountShow = false">
    <div style="text-align: center">
      <div class="f-c-green f-16">{{ byCheckAccount.msg }}</div>
    </div>
  </a-modal>
</template>

<script>
import {computed, createVNode, onMounted, onUnmounted, reactive, toRefs} from "vue";
import {
  addOtaAccountList,
  otaAccountList,
  otaAdd,
  otaByCallBackUrl,
  otaByCheckAccount,
  otaDel,
  otaStatus,
  otaYunZhangGuiGetCityList,
  otaYunZhangGuiRegister,
  smsSend,
} from "@/api/api";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import {verifyAccount} from "@/common/validator";
import {message, Modal} from "ant-design-vue";
// import dayjs from "dayjs";
import axios from "@/utils/request";
import useClipboard from "vue-clipboard3";
// import store from "@/store/pms/landlord/index";
// import $limit from "@/common/limit";
// import { message } from "ant-design-vue";
import useUtils from "@/hooks/useUtils.js";
import store from "@/store/pms/landlord/index";

export default {
  setup() {
    const {diffTime} = useUtils();
    // 搜索
    let search = reactive({
      searchForm: {
        ota_id: 0,
        name: "",
      },
      searchLoading: false,
    });

    // 表格
    let table = reactive({
      dataSource: [],
      columns: [
        {
          title: "所属平台",
          key: "ota_name",
        },
        {
          title: "账号",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "已关联",
          dataIndex: "related_num",
          key: "house_num",
        },
        {
          title: "未关联",
          dataIndex: "not_related_num",
          key: "house_num",
        },
        // {
        //   title: "账号状态",
        //   dataIndex: "status",
        //   key: "status",
        // },
        {
          title: "工作状态",
          dataIndex: "ota_status",
          key: "ota_status",
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
        },
      ],
      getTableList() {
        // 查询 添加渠道账号列表
        addOtaAccountList().then((res) => {
          modal.CompanyOta = res.data;
        });
      },
      // ota 列表
      getOtaList() {
        search.searchLoading = true;
        otaAccountList({
          ota_id: search.searchForm.ota_id,
          name: search.searchForm.name,
        })
            .then((res) => {
              table.dataSource = res.data;
            })
            .finally(() => {
              search.searchLoading = false;
            });
      },
    });

    // 弹窗
    let modal = reactive({
      visibleOtaList: false,
      modalTitle: "",
      showTitle: '',
      yzgGuideShow: false,
      ota_id: 0,
      CompanyOta: [],
      loading: false,
      frameRef: "",
      otaItem: "",
      msShow: false,
      byCallBackUrlShow: false,
      byCheckAccountShow: false,
      yunZhangGuiShow: false,
      byCallBackUrl: '13',
      msFormRef: "",
      msForm: {
        account: "",
        pwd: "",
        ota_id: 0,
        cota_id: 0,
      },
      byCheckAccount: {},

      // 打开全部渠道
      handleAdd() {
        modal.modalTitle = "添加直连账号";
        modal.visibleOtaList = true;
      },

      loginFormRef: "", //表单验证
      rules: {
        username: [
          {
            required: true,
            validator: verifyAccount,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },

      // 民宿确认添加
      handleConfirm() {
        modal.msFormRef.validate().then(() => {
          otaAdd({
            name: modal.msForm.account,
            pwd: modal.msForm.pwd,
            otaId: modal.msForm.ota_id,
            cotaId: modal.msForm.cota_id,
          }).then((res) => {
            message.success(res.msg);
            modal.msShow = false;
            modal.msFormRef.resetFields();
            table.getOtaList();
          });
        });
      },
      // 添加编辑账号
      handleAddEdit(item) {
        console.log(item)
        modal.otaItem = item;
        let otaId_white_list = [6, 17, 19];
        if (item.cota_id) {//重新登录
          if (otaId_white_list.includes(item.id) || otaId_white_list.includes(item.ota_id)) {
            modal.showTitle = item.ota_name + '_' + item.name;
            modal.msForm.ota_id = item.ota_id;
            modal.msForm.cota_id = item.cota_id;
            modal.msForm.account = item.name;
            modal.msForm.pwd = '';
            modal.msShow = true;
            modal.visibleOtaList = false;
            return;
          }

        } else {//添加
          if (item.id == 19) {
            modal.visibleOtaList = false;
            modal.yzgGuideShow = true;
            return;

          } else if (otaId_white_list.includes(item.id) || otaId_white_list.includes(item.ota_id)) {
            modal.showTitle = item.name;
            modal.msForm.ota_id = item.id;
            modal.msForm.cota_id = 0;
            modal.msForm.account = '';
            modal.msForm.pwd = '';
            modal.msShow = true;
            modal.visibleOtaList = false;
            return;
          }
        }

        store.commit("openWindow", item);

        if (modal.loginFormRef) {
          modal.loginFormRef.resetFields();
        }
        modal.visibleOtaList = false;
      },

      // 删除账号
      handleDel(item) {
        Modal.confirm({
          title: "确定要删除渠道账号吗？",
          content:
              "删除渠道账号之后，您的房间仍然存在，不会影响房态、订单、统计等数据。但该账号的房源以及房源和房间的关联关系将全部删除。",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            otaDel({cota_id: item.cota_id}).then((res) => {
              message.success(res.msg);
              table.getOtaList();
            });
          },
        });
      },
      // 删除账号
      handleStatus(item) {
        let status = 1;
        let title = '是否启用?';
        let content = '启用后，您可以正常同步账号下的房源和订单等信息。';
        if (item.status == 1) {
          status = 2;
          title = "是否停用?";
          content = "停用后，账号下的房源及订单信息不再同步。";
        }
        Modal.confirm({
          title: title,
          content: content,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            otaStatus({
              cota_id: item.cota_id,
              status: status
            }).then((res) => {
              message.success(res.msg);
              table.getOtaList();
            });
          },
        });
      },

      // 宝寓回调地址
      handleByCallBackUrl(item) {
        this.byCallBackUrlShow = true;
        otaByCallBackUrl({cota_id: item.cota_id}).then((res) => {
          this.byCallBackUrl = res.data.url;
        });
      },
      // 宝寓账号验证
      handleCheckLine(item) {
        this.byCheckAccountShow = true;
        this.byCheckAccount.msg = '';
        otaByCheckAccount({cota_id: item.cota_id}).then((res) => {
          this.byCheckAccount = res.data;
          table.getOtaList();
          setTimeout(() => {
            this.byCheckAccountShow = false;
          }, 2000)
        });
      },

      readOrderTime(time) {
        return time == 0 ? "" : `${time}秒后重试`;
      },
      // 复制订单号
      handleCopy(value) {
        try {
          useClipboard().toClipboard(value);
          message.success("复制成功");
        } catch (error) {
          message.error("复制失败");
        }
      },

      // 倒计时
      otaTimer: "",
      countDown() {
        modal.otaTimer = setInterval(() => {
          table.dataSource.forEach((item) => {
            item.sync.forEach((it) => {
              if (it.countdown > 0) {
                it.countdown--;
              }
            });
          });
        }, 1000);
      },
    });
    // 弹窗
    let yzgModal = reactive({
      loading: false,
      registerFormRef: "",
      yzgRegisterShow: false,
      yzgRegisterSuccessShow: false,
      yzgPassword: '',
      yzgRegisterForm: {
        user_name: "",
        phone: "",
        code: '',
        city_id: '',
        city_name: '',
        store_name: '',
      },
      codeText: "获取验证码",
      count: null,
      city_list: {},

      // 打开注册云掌柜窗口
      handleReister() {
        modal.msShow = false;
        modal.yzgGuideShow = false;
        yzgModal.yzgRegisterShow = true;
        // otaYunZhangGuiGetCityList
        otaYunZhangGuiGetCityList({})
            .then((res) => {
              yzgModal.city_list = res.data;
            })
            .finally(() => {
              search.searchLoading = false;
            });
      },
      handleYzgLogin() {
        modal.showTitle = "云掌柜";
        modal.msForm.ota_id = 19;
        modal.msForm.cota_id = 0;
        modal.msForm.account = '';
        modal.msForm.pwd = '';
        modal.msShow = true;
        modal.visibleOtaList = false;
        modal.yzgGuideShow = false;
      },
      //获取验证码
      handleGetCode() {
        yzgModal.registerFormRef
            .validate("phone")
            .then(() => {
              smsSend({
                accept_phone: yzgModal.yzgRegisterForm.phone,
              }).then((res) => {
                message.success(res.msg);
                yzgModal.disabled = true;
                yzgModal.codeText = "已发送";
                yzgModal.count = 60;
                // 倒计时
                const timer = setInterval(() => {
                  if (yzgModal.count > 0 && yzgModal.count <= 60) {
                    yzgModal.count -= 1;
                  } else {
                    yzgModal.disabled = false;
                    yzgModal.codeText = "获取验证码";
                    yzgModal.count = null;
                    clearInterval(timer);
                  }
                }, 1000);
              });
            })
            .catch(() => {
              return false;
            });
      },
      filterOption(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },

      disabled: computed(() => {
        if (yzgModal.count) {
          return true;
        }
        if (yzgModal.yzgRegisterForm.phone) {
          return false;
        } else {
          return true;
        }
      }),
      handleChange(e) {
        console.log(e)
        yzgModal.yzgRegisterForm.city_name = yzgModal.city_list.find(city => city.city_id === e).city_name;
      },

      // 云掌柜注册
      handleYzgRegister() {
        console.log(yzgModal.yzgRegisterForm)
        yzgModal.registerFormRef.validate().then(() => {
          otaYunZhangGuiRegister(yzgModal.yzgRegisterForm).then((res) => {
            message.success(res.msg);
            yzgModal.yzgRegisterSuccessShow = true;
            yzgModal.yzgRegisterShow = false;
            yzgModal.yzgPassword = res.data.password;
          });
        });
      },
    });


    // 操作
    let opers = reactive({
      timer: "",
      countDown(item) {
        opers.timer = setInterval(() => {
          item.sync.forEach((it) => {
            if (it.countdown > 0) {
              it.countdown--;
            }
          });
        }, 1000);
      },
      readLoading: false,
      // 账号操作 读取
      handleRead(item) {
        opers.readLoading = true;
        search.searchLoading = true;

        axios({
          method: item.method,
          url: item.url,
          [item.method == "get" ? "params" : "data"]: item.param,
        })
            .then((res) => {
              setTimeout(() => {
                message.success(res.msg);
                table.getOtaList();
                opers.readLoading = false;
                search.searchLoading = false;
              }, 2000);
            })
            .finally(() => {
              setTimeout(() => {
                opers.readLoading = false;
                search.searchLoading = false;
              }, 4000);
            });
      },
    });

    onMounted(() => {
      table.getTableList();
      table.getOtaList();
      modal.countDown();
    });

    onUnmounted(() => {
      clearInterval(modal.otaTimer);
    });

    return {
      diffTime,
      ...toRefs(opers),
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(yzgModal),
    };
  },
};
</script>

<style lang="scss" scoped>
.ota-list {
  display: flex;
  flex-wrap: wrap;

  .ota-one {
    width: 27%;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 8px #5959591f !important;
    padding: 10px;
    margin: 10px;
    cursor: pointer;

    span {
      margin-left: 5px;
    }
  }
}

.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo {
  }

  .title {
    margin-top: 10px;
  }

  .login-form {
    width: 100%;
    margin-top: 30px;
  }
}

.ota-name {
  display: flex;
  align-items: center;

  .name-avatar {
    margin-right: 6px;
  }

  .name-name {
  }
}

.code-container {
  display: flex; /* 使用 Flex 布局 */
  align-items: center; /* 垂直居中 */
}

.code-box {
  flex: 1; /* 输入框占据剩余空间 */
  margin-right: 10px; /* 可以调整输入框和按钮之间的间距 */
}

.label-width {
  width: 180px; /* 你可以根据需要调整宽度 */
}

.yzgGuide {
  border: green 1px solid;
  margin-bottom: 15px;
  border-radius: 5px;
  padding: 15px;
}
</style>
